<template>
    <div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.menu.register.trucker.label.title')}}</h4>
                            </div>
                        </div>
                    </div>

                    <!-- Form row -->
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card-box">
                                <p class="sub-header">
                                    {{$t('string.msg.register.trucker.label.title')}}
                                </p>

                                <form>

                                    <div v-if="data._id" class="form-row">
                                        <div class="form-group col-md-4">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.product.brand.label.id')}}
                                            </label>
                                            <input type="text" readonly v-model="data._id" class="form-control">
                                        </div>

                                        <div class="form-group col-md-2">
                                            <br/>
                                            <br/>
                                            <button v-on:click="confirmArchive" class="text-dark-gray btn btn-warning w-100">{{$t('string.msg.status.archive')}}</button>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.trucker.label.name')}}
                                            </label>
                                            <input type="text" v-model="data.firstName" class="form-control" :placeholder="$t('string.msg.trucker.placeholder.name')">
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.trucker.label.lastname')}}
                                            </label>
                                            <input type="text" v-model="data.lastName" class="form-control" :placeholder="$t('string.msg.trucker.placeholder.lastname')">
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                {{$t('string.msg.trucker.label.rg')}}
                                            </label>
                                            <input type="text" v-model="data.customerUser.rg" class="form-control" v-mask="['###########']" :placeholder="$t('string.msg.trucker.placeholder.rg')">
                                        </div>
                                    </div>

                                    <div class="form-row">

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                 {{$t('string.msg.trucker.label.cpf')}}
                                            </label>
                                            <input type="text" v-model="data.customerUser.document" class="form-control" v-mask="['###.###.###-##']" :placeholder="$t('string.msg.trucker.placeholder.cpf')">
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.trucker.label.phone')}}
                                            </label>
                                            <input type="text" v-model="data.primaryPhone" class="form-control" :placeholder="$t('string.msg.trucker.placeholder.phone')" v-mask="['(##) ####-####', '(##) #####-####']">
                                        </div>
   
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                               {{$t('string.msg.trucker.label.birthday')}}
                                            </label>
                                            
                                            <input type="text" v-model="data.customerUser.dateBirth" class="form-control" :placeholder="$t('string.msg.trucker.placeholder.birthday')" v-mask="['##/##/####']">
                                          
                                        </div>
                                    </div>

                                    <div class="form-row">

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                {{$t('string.msg.trucker.label.gender')}}
                                            </label>
                                            <select v-model="data.customerUser.gender" class="form-control">
                                                <option :value="null" selected>{{$t('string.msg.trucker.label.gender.select')}}</option>
                                                <option value="M">{{$t('string.msg.trucker.label.gender.male')}}</option>
                                                <option value="F">{{$t('string.msg.trucker.label.gender.female')}}</option>
                                            </select>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                {{$t('string.msg.trucker.label.cnh')}}
                                            </label>
                                            <input type="text" v-model="data.customerUser.cnh" class="form-control" v-mask="['############']" :placeholder="$t('string.msg.trucker.placeholder.cnh')">
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                {{$t('string.msg.trucker.label.obs')}}
                                            </label>
                                            <input type="text" v-model="data.customerUser.obsCNH" class="form-control" :placeholder="$t('string.msg.trucker.placeholder.obs')">
                                        </div>

                                    </div>
                                    <br/>
                                    <div class="form-row">

                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.trucker.label.password')}}
                                            </label>
                                            <input type="password" v-model="data.password" class="form-control" :placeholder="$t('string.msg.trucker.placeholder.password')">
                                        </div>
                                    </div>
                                    <br>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                 {{$t('string.msg.trucker.label.cnh-attachment')}}
                                            </label>
                                            <input type="file" id="cnh" ref="file" v-on:change="handleFileUpload()" class="form-control">
                                        </div>
                                        <div v-if="data.customerUser.cnhPhotoURL" class="form-group col-md-5">
                                            <label class="col-form-label">
                                                {{$t('string.msg.trucker.photo.label')}}
                                            </label>
                                            <div class="card border border-secondary cursor-pointer">
                                                <div class="card-body text-secondary text-center">
                                                    <div v-if="data.customerUser.cnhPhotoURL" @click="showPhoto(data.customerUser.cnhPhotoURL)" class="card-body text-secondary text-center">
                                                        <img v-bind:src="`${domain}${data.customerUser.cnhPhotoURL}`" alt="image" height="180" width="250">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br/>
                                    
                                    <div class="form" v-show="data._id">
                                        
                                        <div class="form-row">
                                            <div class="col-md-12">
                                                <h5>
                                                    {{$t('string.msg.modal.orders.truck.infos')}}
                                                </h5>
                                            </div>
                                        </div>

                                        <div class="table-responsive" v-if="trucks && trucks.length > 0">
                                            <table class="table table-centered table-hover mb-0" id="datatable">
                                                <thead>
                                                    <tr>
                                                        <th class="border-top-0">{{$t('string.msg.truck.table.header.vehicle.type')}}</th>
                                                        <th class="border-top-0">{{$t('string.msg.truck.table.header.manufacture')}}</th>
                                                        <th class="border-top-0">{{$t('string.msg.truck.table.header.model')}}</th>
                                                        <th class="border-top-0">{{$t('string.msg.truck.table.header.year')}}</th>
                                                        <th class="border-top-0">{{$t('string.msg.truck.table.header.Placa')}}</th>
                                                        <th class="border-top-0">{{$t('string.msg.list.trucks.table.certifieds')}}</th>
                                                    </tr>
                                                </thead>
                                                <tbody v-bind:key="item._id" v-for="item in trucks" class="cursor-pointer">
                                                    <tr>
                                                        <td>
                                                            <span>  
                                                                {{ $t(item.vehicleType).toString().toUpperCase()}}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span>  
                                                                {{item.manufacturer.name}}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span v-if="item.model && item.model.name">
                                                                {{item.model.name}}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span>
                                                             {{item.year}}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span>   
                                                             {{item.plate}}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span v-bind:key="item" v-for="item in item.certifies">   
                                                                            {{item.certified.name + ' / '}}
                                                             </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div v-else class="form-row">
                                            <div class="col-md-12">
                                                <h5 style="color:red">
                                                    {{$t('string.msg.user.type.customer.zero.trucks')}}
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                    <br>
                                    <br>

                                    <div class="form-row">
                                        <div class="form-group col-md-6 text-center">
                                            <button @click="clearForm" class="btn btn-secondary w-50">{{$t('string.msg.form.btn.clear')}}</button>
                                        </div>

                                        <div class="form-group col-md-6 text-center">
                                            <button v-on:click="checkForm" class="btn btn-danger w-50">{{$t('string.msg.form.btn.save')}}</button>
                                        </div>
                                    </div>
                                    <br/>
                                    <div v-if="errors.length" class="alert alert-danger">
                                        <p class="lead">{{$t('response.msg.error.empty.fields')}}</p>
                                        <ul>
                                            <li v-bind:key="error" v-for="error in errors">{{ error }}</li>
                                        </ul>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                    <List v-on:load-item="selectItem" />
                </div>
            </div>
        </div>

        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
        <Confirmation :title="titleToast" :message="messageToast" :cancelText="cancelText" :yesText="yesText" v-on:confirmation-return="archive" />
        <FlashMessage/>
        <Photo :photoURL="photoURL" />
    </div>
</template>

<script>
import Controller from './CrtTrucker';
import Spinner from '../../../../components/layout/Spinner';
import Toast from '../../../../components/layout/Toast';
import Confirmation from '../../../../components/layout/Confirmation';
import List from './ListTrucker';
import Photo from '../../../../components/layout/ModalPhoto';
import {ptBR} from 'vuejs-datepicker/dist/locale'
import Vue from 'vue';
Vue.prototype.$eventHub = new Vue();
Vue.use(require('vue-moment'));


let maxDate = new Date();
export default {
  name: 'Trucker',
  components: {
    Spinner,
    Toast,
    List,
    Photo,
    Confirmation
  },
  data() {
      return {
        errors: [],
         disabledDates: {
            from: maxDate, // Disable all dates before specific date
        },
        valuekey: 0,
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        companies:[],
        ptBR: ptBR,
        trucks: null,
        datetime:null,
        truckers: [],
        nTruckers: null,
       data: {
            firstName: null,
            lastName: null,
            email: null,
            password: null,
            primaryPhone: null,
            type: "USER-CUSTOMER",
                customerUser: {
                subtype: "TRUCK_DRIVER",
                dateBirth: null,
                document: null,
                cnh: null,
                rg: null,
                selfiePhotoURL: 'xxxxx',
                obsCNH: null,
                gender: null,
                company: null,
                oldCnhPhotoURL: null,
            }
        }
    }
  },
  methods: Controller.methods,
  created() {
  },
  computed: {
  },
  mounted(){
      Controller.init(this);
  }
}
</script>

<style>
</style>